import { AccordionItem, AccordionItemContent } from '@e3dc-react/shell/Elements/Accordion'
import { AccordionItemProps } from '@e3dc-react/shell/Elements/Accordion/AccordionItem'
import React from 'react'

type Props = Pick<AccordionItemProps, 'title' | 'expanded' | 'callback'> & {
  children: React.ReactNode
}

const AccordionWrapper: React.FC<Props> = ({ children, ...props }) => {
  return (
    <AccordionItem {...props}>
      <AccordionItemContent variant="paper">{children}</AccordionItemContent>
    </AccordionItem>
  )
}

export default AccordionWrapper
